import fs from 'node:fs'
import path from 'node:path'
import type { ProjectInfo } from '@cli-types/next-adapter/config.js'
import { NEXT_CONFIG_FILES } from '@cli-constants/lint-configs.js'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { validateAdminNamespace } from '@next-adapter/config/namespace/validate-admin-namespace.js'
import { detectLinter } from './detect-linter.js'
import { detectTailwind } from './detect-tailwind.js'
import { hasTsconfigAdminAliases } from './has-tsconfig-admin-aliases.js'

export function detectProject(cwd: string, namespaceValue = DEFAULT_ADMIN_NAMESPACE): ProjectInfo {
  const namespace = validateAdminNamespace(namespaceValue)
  const isExisting = NEXT_CONFIG_FILES.some((f) => fs.existsSync(path.join(cwd, f)))

  const hasSrcDir = fs.existsSync(path.join(cwd, 'src'))

  const hasTypeScript =
    fs.existsSync(path.join(cwd, 'tsconfig.json')) ||
    fs.existsSync(path.join(cwd, 'tsconfig.app.json'))

  const hasTailwind = detectTailwind(cwd)
  const linter = detectLinter(cwd)

  const conflicts: string[] = []
  if (isExisting) {
    if (fs.existsSync(path.join(cwd, namespace))) {
      conflicts.push(`${namespace}/ directory already exists`)
    }
    if (fs.existsSync(path.join(cwd, CONFIG_FILE_NAME))) {
      conflicts.push(`${CONFIG_FILE_NAME} already exists`)
    }

    const appBase = hasSrcDir ? 'src/app' : 'app'
    if (fs.existsSync(path.join(cwd, appBase, `(${namespace})`))) {
      conflicts.push(`${appBase}/(${namespace})/ route group already exists`)
    }

    if (hasTsconfigAdminAliases(cwd, namespace)) {
      conflicts.push(`@${namespace}/* path aliases already exist in tsconfig.json`)
    }
  }

  return { isExisting, hasSrcDir, hasTypeScript, hasTailwind, linter, conflicts }
}
